/*
TODO: Mixpanel events
*/

import React, { useState } from 'react';
import { StyleSheet, View } from 'react-native';

import { useInstallmentPlanQuery } from 'apollo/queries/autogenerate/hooks';
import { paymentDataFragment } from 'apollo/queries/autogenerate/operations';
import { InstallmentPlan } from 'apollo/queries/autogenerate/schemas';
import Dialog from 'shared/modules/common/components/atoms/Dialog';
import InstallmentPlanView from 'web/modules/common/components/molecules/InstallmentPlanView';
import ReceiptDialog, {
  useReceiptDialog,
} from 'web/modules/common/components/organisms/ReceiptDialog';
type Props = {
  installmentPlanId: string;
  currentInstallmentIndex: number;
  onCloseButtonPress: () => void;
  open: boolean;
};

export default function InstallmentPlanDialog(props: Props) {
  const { data, loading } = useInstallmentPlanQuery({
    variables: { id: props.installmentPlanId },
    fetchPolicy: 'cache-and-network',
  });
  const receiptDialog = useReceiptDialog();

  const installmentPlan = data?.installmentPlan;

  if (loading) {
    return null;
  }

  if (!installmentPlan) {
    return null;
  }

  const handleViewReceiptPress = () => {
    // Mixpanel.trackClickAction({
    //   screen: 'Receipt',
    //   itemName: 'Show Receipt',
    // });
    receiptDialog.openWithPayment(
      installmentPlan.payment as paymentDataFragment
    );
  };

  return (
    <Dialog
      title=""
      onCloseButtonPress={props.onCloseButtonPress}
      open={props.open}
      style={styles.container}
      id="installment-plan-dialog"
    >
      <View style={styles.body}>
        <InstallmentPlanView
          installmentPlan={installmentPlan as InstallmentPlan}
          currentInstallmentIndex={props.currentInstallmentIndex}
          onViewReceiptPress={handleViewReceiptPress}
        />

        {receiptDialog.payment && (
          <ReceiptDialog
            payment={receiptDialog.payment}
            installmentPlan={installmentPlan as InstallmentPlan}
            open={receiptDialog.isOpen}
            onCloseButtonPress={receiptDialog.close}
          />
        )}
      </View>
    </Dialog>
  );
}

const styles = StyleSheet.create({
  container: {
    width: '100%',
    maxWidth: 424,
    paddingBottom: 0,
  },
  body: {
    marginHorizontal: -24,
    backgroundColor: '#f6f8fa',
  },
});

export function useInstallmentPlanDialog() {
  const [installmentPlanId, setInstallmentPlanId] = useState<string>();
  const [currInstallmentIndex, setCurrInstallmentIndex] = useState(-1);
  const [isOpen, setIsOpen] = useState(false);

  const open = (_installmentPlanId: string, _installmentIndex: number) => {
    setInstallmentPlanId(_installmentPlanId);
    setCurrInstallmentIndex(_installmentIndex);
    setIsOpen(true);
  };

  const close = () => {
    setIsOpen(false);
  };

  return {
    installmentPlanId,
    currInstallmentIndex,
    isOpen,
    open,
    close,
  };
}
